var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoreArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25.826 15.742"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.412 1.413l-11.5 11.5-11.5-11.5",
    fill: "none",
    stroke: "#ece8e1",
    strokeWidth: 4
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNS44MjYgMTUuNzQyIj4KICA8cGF0aCBkPSJNMCwxMS41LDExLjUsMCwyMywxMS41IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyNC40MTIgMTIuOTEzKSByb3RhdGUoMTgwKSIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjZWNlOGUxIiBzdHJva2Utd2lkdGg9IjQiLz4KPC9zdmc+Cg==";
export { SvgMoreArrow as ReactComponent };